import * as React from "react"
import styled, { keyframes } from "@digits-css"
import { svgIconStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgDigitsLogo } from "@digits-shared/components/SVGIcons/digits/DigitsLogo.svg"
import colors from "@digits-shared/themes/colors"
import "./Page.digits.css"

/*
  STYLES
*/

const FADE_IN = keyframes({ name: "_735a555" })

const FADE_IN_OUT = keyframes({ name: "_fea5131" })

const LogoLoadingContainer = styled.div({ cls: "_7051823", cssVarMap: { "$size": "--size", "$delay": "--delay" } })

const SvgDigitsLogoStyled = styled(SvgDigitsLogo, { cls: "_0095439", cssVarMap: { "$color": "--color", "$moduleLoadingColor": "--module-loading-color", "$iconColor": "--icon-color" } })

/*
  INTERFACES
*/

interface LogoLoadingProps {
  size: string
  delay?: string
  color?: string
}

/*
  COMPONENTS
*/
export const LogoLoading = ({ color, size, delay }: LogoLoadingProps) => (
  <LogoLoadingContainer $size={size} $delay={delay}>
    <SvgDigitsLogoStyled $color={color} />
  </LogoLoadingContainer>
)
